<!--
 * @Description:
 * @Author: zwcong
 * @Date: 2025-07-25 17:34:08
 * @LastEditors: zwcong
 * @LastEditTime: 2025-08-01 14:50:08
-->
<template>
  <div>
    <Header :sticky-status="headerStickyStatus" :theme-class="headerThemeClass" />
    <NameIntro :config="nameIntro" />
    <LogoIntro :config="logoIntro" />
    <EducationConcept :config="educationConcept" />
    <DevelopmentHistory :config="developmentHistory" />
    <AboutTal :config="aboutTal" />
    <BMFooter v-if="locale==='bmus'" />
    <UsOnlineWebFooter v-else-if="showNewUsHeader" />
    <Footer v-else />
  </div>
</template>

<script>
import Header from '@/components/global/FeatureComponents/Header/web';
import Footer from '@/components/global/FeatureComponents/Footer/webNew.vue'
import UsOnlineWebFooter from '@/components/global/FeatureComponents/Footer/UsOnlineWeb'
import BMFooter from '@/components/global/FeatureComponents/BMFooter/web'
import NameIntro from 'components/aboutUs/NameIntro/index';
import LogoIntro from 'components/aboutUs/LogoIntro/index';
import EducationConcept from 'components/aboutUs/EducationConcept/index';
import AboutTal from 'components/aboutUs/AboutTal/index';
import DevelopmentHistory from 'components/aboutUs/DevelopmentHistory/index';

export default {
  layout: 'simpleLayout',
  components: {
    Header,
    NameIntro,
    LogoIntro,
    Footer,
    EducationConcept,
    AboutTal,
    DevelopmentHistory,
    BMFooter,
    UsOnlineWebFooter,
  },
  async fetch({ store, error }) {
    const { locale } = store.state;
    if (locale !== 'hk') {
      const params = {
        statusCode: 404,
      };
      error(params);
    }
  },
  data() {
    return {
      // 导航吸顶状态
      headerStickyStatus: false,
      nameIntro: this.$t('aboutUs.nameIntro'),
      logoIntro: this.$t('aboutUs.logoIntro'),
      educationConcept: this.$t('aboutUs.educationConcept'),
      aboutTal: this.$t('aboutUs.aboutTal'),
      developmentHistory: this.$t('aboutUs.developmentHistory'),
    }
  },
  computed: {
    // 导航主题样式
    headerThemeClass() {
      return this.headerStickyStatus ? '' : 'skin-orange';
    },
    locale() {
      return this.$store.state.locale
    },
    thinkType() {
      return this.$store.state.thinkType
    },
    schoolCode() {
      return this.$store.state.schoolCode
    },
    isGray() {
      return (process.env.grayType || '').toLowerCase() === 'gray';
    },
    showNewUsHeader() {
      // us mars uk ca jp kr fr
      const schoolList = ['415', '8601', '4401', '103', '8101', '8201', '3301']
      console.log('thinkType is ----', this.thinkType)
      if (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'online') {
        return true;
      }
      return false;
    },
  },
}
</script>
